import React from 'react';
import PropTypes from 'prop-types'
// import classNames from 'classnames';

import Card from '../common/card'

import Offer_1 from '../../images/offer1.jpg'
import Offer_2 from '../../images/offer2.jpg'
import Offer_3 from '../../images/offer3.jpg'

const OfferCards = (props) => (
  <React.Fragment>
    <div className="col-xs-4"><Card image_url={Offer_1} /></div>
    <div className="col-xs-4"><Card image_url={Offer_2} /></div>
    <div className="col-xs-4"><Card image_url={Offer_3} /></div>
  </React.Fragment>
)

OfferCards.propTypes = {
  url: PropTypes.string,
  image_url: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string
};

export default OfferCards;
